"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiErrorResponse = instanceOfApiErrorResponse;
exports.ApiErrorResponseFromJSON = ApiErrorResponseFromJSON;
exports.ApiErrorResponseFromJSONTyped = ApiErrorResponseFromJSONTyped;
exports.ApiErrorResponseToJSON = ApiErrorResponseToJSON;
exports.ApiErrorResponseToJSONTyped = ApiErrorResponseToJSONTyped;
/**
 * Check if a given object implements the ApiErrorResponse interface.
 */
function instanceOfApiErrorResponse(value) {
    return true;
}
function ApiErrorResponseFromJSON(json) {
    return ApiErrorResponseFromJSONTyped(json, false);
}
function ApiErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
        'debugMessage': json['debugMessage'] == null ? undefined : json['debugMessage'],
    };
}
function ApiErrorResponseToJSON(json) {
    return ApiErrorResponseToJSONTyped(json, false);
}
function ApiErrorResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'message': value['message'],
        'requestId': value['requestId'],
        'debugMessage': value['debugMessage'],
    };
}
